<template>
	<div class="colleagueFinder">
		<o-collapse v-model:open="collapsed" aria-id="contentId">
			<template #trigger>
				<a href="javascript://" aria-controls="contentId">
					<span v-if="collapsed">Hide filters</span>
					<span v-else>Show filters</span>
				</a>
			</template>
			<template v-slot:default>
				<o-field label="Company">
					<autocomplete v-model="company" type="company" @input="AddCompany"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-for="(row, i) in companies" :key="i">
					<span class="mr-2">{{ row.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="RemoveCompany(i)"></a>
					</span>
				</div>
				<o-field label="Industry">
					<autocomplete
						type="industry"
						clearOnSelect
						@input="
							(p) => {
								industry = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="industry">
					<span class="mr-2">{{ industry.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									industry = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Function">
					<autocomplete
						type="function"
						clearOnSelect
						@input="
							(p) => {
								jfunction = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="jfunction">
					<span class="mr-2">{{ jfunction.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									jfunction = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Practice group">
					<autocomplete
						type="practiceGroup"
						clearOnSelect
						@input="
							(p) => {
								practiceGroup = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="practiceGroup">
					<span class="mr-2">{{ practiceGroup.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									practiceGroup = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Subsector group">
					<autocomplete
						type="subsector"
						clearOnSelect
						@input="
							(p) => {
								subsector = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="subsector">
					<span class="mr-2">{{ subsector.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									subsector = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Region">
					<autocomplete
						type="region"
						clearOnSelect
						@input="
							(p) => {
								region = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="region">
					<span class="mr-2">{{ region.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									region = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="License">
					<autocomplete
						type="license"
						clearOnSelect
						@input="
							(p) => {
								license = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="license">
					<span class="mr-2">{{ license.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									license = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Location">
					<autocomplete
						type="location"
						clearOnSelect
						@input="
							(p) => {
								location = p;
								GetUsers();
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-if="location">
					<span class="mr-2">{{ location.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									location = null;
									GetUsers();
								}
							"></a>
					</span>
				</div>

				<o-field label="Skill">
					<autocomplete
						type="skill"
						clearOnSelect
						:disabled="skills.length >= 3"
						@input="
							(p) => {
								if (skills.length < 3) {
									skills.push(p);
									GetUsers();
								}
							}
						"></autocomplete>
				</o-field>
				<div class="tag mx-2 my-2" v-for="(s, i) in skills" :key="i">
					<span class="mr-2">{{ s.text }}</span>
					<span>
						<a
							role="button"
							aria-label="Close tag"
							tabindex="0"
							class="delete is-small"
							@click="
								() => {
									skills.splice(i, 1);
									GetUsers();
								}
							"></a>
					</span>
				</div>
			</template>
		</o-collapse>

		<div class="results">
			<loading v-show="loading"></loading>
			<h3 class="mt-5" v-show="!loading">Top results</h3>
			<div class="partner-info my-2" v-for="p in list" :key="p.ID">
				<div>
					<user-picture :user="p" size="large"></user-picture>
					<div class="is-flex is-flex-direction-column mt-2">
						<div>
							<h3>{{ p.firstName }} {{ p.lastName }}</h3>
							<span class="has-text-grey">Teaming value</span>
							<!-- <div>
								<strong>{{ cformat(p.partnerSplitUsd) }}</strong>
							</div> -->
							<div>
								<strong>{{ p.location }}</strong>
							</div>
							<div>
								<a
									:href="'https://mysite.boyden.net/Person.aspx?accountname=BOYDEN\\' + p.adlogin"
									target="_blank">
									Visit profile
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { ref, inject, onMounted } from "vue";
	import { autocomplete } from "@/components/webComponents";
	import { currencyFormat } from "@/services/utils";

	export default {
		components: {
			autocomplete
		},
		props: {},
		setup(props, context) {
			const http = inject("$http");
			const cformat = ref(currencyFormat.format);

			const loading = ref(false);
			const collapsed = ref(false);
			const list = ref([]);
			const company = ref();
			const companies = ref([]);
			const industry = ref();
			const practiceGroup = ref();
			const subsector = ref();
			const jfunction = ref();
			const region = ref();
			const license = ref();
			const location = ref();
			const skills = ref([]);

			const GetUsers = async () => {
				loading.value = true;

				const body = {
					companies: [],
					industry: [],
					function: [],
					practiceGroup: [],
					subsector: [],
					region: [],
					license: [],
					location: [],
					skills: []
				};
				if (companies.value.length > 0) {
					body.companies = companies.value;
				}
				if (industry.value) {
					body.industry.push(industry.value.id);
				}
				if (jfunction.value) {
					body.function.push(jfunction.value.id);
				}
				if (practiceGroup.value) {
					body.practiceGroup.push(practiceGroup.value.id);
				}
				if (subsector.value) {
					body.subsector.push(subsector.value.id);
				}
				if (region.value) {
					body.region.push(region.value.id);
				}
				if (license.value) {
					body.license.push(license.value.id);
				}
				if (location.value) {
					body.location.push(location.value.id);
				}
				if (skills.value && skills.value.length > 0) {
					body.skills = skills.value.slice();
				}

				try {
					const response = await http.post("/api/v2/widget/colleagueFinder", body);
					list.value = response.data;
				} catch (err) {
					console.error(err);
				}

				loading.value = false;
			};

			const AddCompany = (row) => {
				companies.value.push(row);
				row.ClearText();

				GetUsers();
			};
			const RemoveCompany = (index) => {
				companies.value.splice(index, 1);

				GetUsers();
			};

			onMounted(() => {
				GetUsers();
			});

			return {
				cformat,
				loading,
				collapsed,
				list,
				company,
				companies,
				industry,
				practiceGroup,
				subsector,
				jfunction,
				region,
				license,
				location,
				skills,
				GetUsers,
				AddCompany,
				RemoveCompany
			};
		}
	};
</script>
<style lang="scss" scoped>
	// .colleagueFinder {

	// }
</style>